import { createStore, featureFlagsStore } from '@packages/stores';

export const useFeatureFlagsStore = createStore(featureFlagsStore, {
  name: 'useFeatureFlagsStore',
  persistType: 'sessionStorage',
});
